import { Option } from '@/components/inputs/AutocompleteInput';
import { useGetDriversQuery } from '../../Drivers/services';
import { useState, useMemo } from 'react';

export const useDriverOptions = () => {
  const [driverSearch, setDriverSearch] = useState('');
  const [selectedDriver, setSelectedDriver] = useState<Option | null>(null);

  const { data: driversData, isLoading: isDriversLoading } = useGetDriversQuery(
    {
      filters: { search: driverSearch },
      paginated: { page: 1, pageSize: 20 },
    },
    { skip: driverSearch.length < 3 }
  );

  const driverOptions: Option[] = useMemo(() => {
    return (driversData?.items ?? []).map((driver) => ({
      label: `${driver.firstName} ${driver.lastName}`,
      data: driver.id,
    }));
  }, [driversData]);

  const resetDriver = () => {
    setDriverSearch('');
    setSelectedDriver(null);
  };

  return {
    driverSearch,
    setDriverSearch,
    selectedDriver,
    setSelectedDriver,
    driverOptions,
    isDriversLoading,
    resetDriver,
  };
};

export default useDriverOptions;
